import withBookingCurrency from 'components/queries/withBookingCurrencyQuery';
import PaymentsContainer from './PaymentsContainer';

export default withBookingCurrency(PaymentsContainer);
